import React, { useEffect, useState } from 'react';
import loginAPI from '../../utils/ajax';
import Footer from '../common/footer';
import Header from '../common/header';
import swal from 'sweetalert';
import clevertap from 'clevertap-web-sdk';

const ResetPassword = (e) => {
  const [load, setload] = useState(false);
  const [email, setemail] = useState(localStorage.getItem('email'));
  const [disable, setdisable] = useState(true);
  const [OTP, setOTP] = useState('');
  const [lockUntil, setLockUntil] = useState(null);
  const [timeLeft, setTimeLeft] = useState(0);

  const reset = async (e) => {
    let validationflag = 0;
    var strong =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*?[~`!@#$%\^&*()\-_=+[\]{};:\x27.,\x22\\|/?><])(?=.{8,})/;
    const npass = document.getElementById('npass').value;
    const rpass = document.getElementById('rpass').value;
    if (!npass.match(strong)) {
      validationflag = 1;
      document
        .getElementById('npass')
        .setCustomValidity(
          'Minimum 8 character, 1 lower case, 1 upper case, 1 number, 1 special character'
        );
    } else {
      document.getElementById('npass').setCustomValidity('');
    }
    if (rpass !== npass) {
      validationflag = 1;
      // document.getElementById('rpass').setCustomValidity('Minimum 8 character, 1 lower case, 1 upper case, 1 number')
    }
    const a = validationflag !== 1 ? await e.preventDefault() : '';
    if (validationflag !== 1) {
      const [response, error] = await loginAPI(
        'POST',
        'auth/angelbroking/client/v1/updatePassword',
        {},
        { email: email, password: npass, otpcode: OTP },
        {}
      );
      if (response.status) {
        swal({
          text: response.message,
          icon: 'success',
          dangerMode: false,
        }).then(() => {
          localStorage.removeItem('email');
          window.location.href = '/';
        });
        clevertap.event.push('password_reset_successful');
      } else {
        // setpasserr(response.message)
        swal({
          text: response.message,
          icon: 'warning',
          //   dangerMode: true
        });
      }
      if (error) {
      }
    }
  };

  useEffect(() => {
    const storedLockUntil = localStorage.getItem('resetLockUntil');
    if (storedLockUntil && Number(storedLockUntil) > Date.now()) {
      setLockUntil(Number(storedLockUntil));
      setdisable(true);
    }

    const interval = setInterval(() => {
      if (lockUntil) {
        const now = Date.now();
        const remaining = lockUntil - now;

        if (remaining <= 0) {
          setLockUntil(null);
          setdisable(false);
          setTimeLeft(0);
          localStorage.removeItem('resetLockUntil');
          clearInterval(interval);
        } else {
          setTimeLeft(Math.floor(remaining / 1000));
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [lockUntil]);

  const validateOtp = async (e) => {
    if (e.target.value.length == 6) {
      const otp = e.target.value;
      const [response, error] = await loginAPI(
        'POST',
        'auth/angelbroking/client/v1/validateOTP',
        {},
        { email: email, otpcode: e.target.value },
        {}
      );
      if (response.status) {
        swal({
          text: response.message,
          icon: 'success',
          dangerMode: false,
        }).then(() => {
          setOTP(otp);
          setdisable(false);
        });
      } else {
        if (
          response.message ===
          'Max invalid otp attempt limit reached. Please try after sometime.'
        ) {
          const lockTime = Date.now() + 15 * 60 * 1000;
          setLockUntil(lockTime);
          setdisable(true);
          localStorage.setItem('resetLockUntil', lockTime);
        }
        swal({
          text: response.message,
          icon: 'warning',
          //   dangerMode: true
        });
      }
      if (error) {
      }
    }
  };
  const cpasschange = (e) => {
    const npass = document.getElementById('npass').value;
    if (e.target.value != npass) {
      document.getElementById('rpass').style.border = '1px solid red';
    } else {
      document.getElementById('rpass').style.border = '';
    }
  };

  return (
    <div className='api-web api-web-reset-password'>
      <div className='container-boxed'>
        <Header />

        <div className='container d-flex f-d-c'>
          <div className='heading'>
            <img
              className='left-caret'
              src='/img/bg-top-left-small-caret.svg'
            />
            <div className='title-container'>
              <h1 className='bar-above'>Reset Password</h1>
            </div>
          </div>
          <div className='main'>
            <div className='layout-left'>
              <form>
                <div className='form-boxed'>
                  <div className='form-group'>
                    <label>OTP</label>
                    <input
                      type='number'
                      placeholder='Enter OTP'
                      disabled={!disable || lockUntil}
                      style={{ cursor: !disable ? 'no-drop' : '' }}
                      maxLength='6'
                      onChange={validateOtp}
                      required
                    />
                    {lockUntil && (
                      <div className='err'>
                        Too many failed attempts. Try again in{' '}
                        {Math.floor(timeLeft / 60)}m {timeLeft % 60}s.
                      </div>
                    )}
                  </div>

                  {/* <p class="h6 mb-2">*Minimum 8 characters, 1 lower case, 1 upper case, 1 number</p> */}

                  <div className='form-group'>
                    <label>New Password</label>
                    <small>
                      *Minimum 8 characters, 1 lower case, 1 upper case, 1
                      number
                    </small>
                    <input
                      type='password'
                      id='npass'
                      placeholder='Enter New Password'
                      required
                      disabled={disable}
                      style={{ cursor: disable ? 'no-drop' : '' }}
                      pattern='[a-zA-Z0-9!#@$&_]{8,}'
                    />
                  </div>

                  <div className='form-group'>
                    <label>Confirm Password</label>
                    <input
                      type='password'
                      id='rpass'
                      placeholder='Enter to Confirm Password'
                      pattern='[a-zA-Z0-9!#@$&_]{8,}'
                      onChange={cpasschange}
                      disabled={disable}
                      style={{ cursor: disable ? 'no-drop' : '' }}
                      required
                    />
                  </div>

                  <button
                    type='submit'
                    className='btn btn-primary btn-lg m-t-5'
                    disabled={disable}
                    style={{ cursor: disable ? 'no-drop' : '' }}
                    onClick={reset}
                  >
                    Reset Password
                  </button>
                </div>
              </form>
            </div>

            <div className='layout-right'>
              <img
                className='main-img-v2'
                src='/img/reset-password-img-1.png'
                width='543'
                height='632'
              />
            </div>
          </div>
        </div>

        <div className='spacer' style={{ height: '5vmin' }}></div>

        <Footer />
      </div>
    </div>
  );
};
export default ResetPassword;
